import React, { MouseEventHandler, useState } from "react";
import cn from "classnames";
import styled from "styled-components";
import { useAppSelector } from "src/store/actions/action";
import { shallowEqual } from "react-redux";

interface IProcessProps {
  progressValue?: string;
  onClick?: MouseEventHandler<HTMLButtonElement> | any;
}

const AsProcessItem = (props: IProcessProps) => {
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);
  const example = [];
  if (userInfo.user_type === "S") {
    if (props.progressValue === "20") {
      example.push({
        code: "U",
        name: "수정하기",
      });
      example.push({
        code: "D",
        name: "삭제하기",
      });
    }
  } else if (userInfo.user_type === "E") {
    example.push({
      code: "C",
      name: "진행완료",
    });
    example.push({
      code: "Q",
      name: "접수종료",
    });
    if (userInfo.user_id == "m1") {
      example.push({
        code: "E",
        name: "신고하기",
      });
      example.push({
        code: "F",
        name: "차단하기",
      });
    }
  }

  return (
    <>
      {example.map((v, i) => {
        return (
          <li key={i}>
            <ProcessItemSet
              onClick={() => {
                props.onClick!(v.code);
              }}
            >
              {v.name}
            </ProcessItemSet>
          </li>
        );
      })}
    </>
  );
};

const ProcessItemSet = styled.button`
  width: 100%;
  padding: 30px 0;
  border: none;
  background: none;
  color: #7f7f7f;
  font-size: 25px;
  font-family: "Roboto";
`;

export default AsProcessItem;
